import { cn } from "@/lib/utils";
import { Message } from "types/conversationInbox";

const SENTIMENT_MAP: Record<
  number,
  { label: string; className: string; icon: string }
> = {
  1: {
    label: "Positive",
    className: "text-green-600 bg-green-50",
    icon: "fa-regular fa-face-smile",
  },
  2: {
    label: "Negative",
    className: "text-red-600 bg-red-50",
    icon: "fa-regular fa-face-frown",
  },
  3: {
    label: "Neutral",
    className: "text-neutral-500 bg-neutral-100",
    icon: "fa-regular fa-face-meh",
  },
  4: {
    label: "Mixed",
    className: "text-yellow-600 bg-yellow-50",
    icon: "fa-regular fa-face-meh-blank",
  },
  5: {
    label: "Unknown",
    className: "text-neutral-400 bg-neutral-50",
    icon: "fa-regular fa-circle-question",
  },
};

interface SentimentBadgeProps {
  sentiment: Message["sentiment"];
  className?: string;
}

export function SentimentBadge({ sentiment, className }: SentimentBadgeProps) {
  if (!sentiment?.type) return null;

  const config = SENTIMENT_MAP[sentiment.type];
  if (!config) return null;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none",
        config.className,
        className
      )}
      title={config.label}
    >
      <i className={cn(config.icon, "text-[9px]")} />
      {config.label}
    </span>
  );
}
